



















































































































































































import {
    Component,
    Vue,
} from "vue-property-decorator";
import RoleLazydropdown from "@/components/lazyDropdown/RoleLazydropdown.vue";

@Component({
    components: {
        RoleLazydropdown
    }
})

export default class CreditApplication extends Vue {
    public loading: boolean = false;

    public form: any = {
        upload_policy_url: "",
        policy_strict: false,
        defaulter_count: 0,
        max_request_per_month: 0,
        max_credit_period: 0,
        closed_time_period: 0,
        check_lists: [{
            name: "",
            attachment: false
        }],
        approval_layers: [{
            role_id: "",
            role_name: '',
            layer: 1,
        }],
        collection_approval_layers: [{
            role_id: "",
            role_name: '',
            layer: 1,
        }]
    };

    public TYPES = {
        CHECK_LIST: 'checkList',
        APPROVAL_LAYER: 'approvalLayer',
        COLLECTION_LAYER: 'collectionApprovalLayer'
    }

    created() {
        this.initFetch();
    }

    async initFetch() {
        await this.$http.get(this.$api('/credit-setting')).then((res: any) => {
          if (!res.data.creditSetting) return;
            this.form = res.data.creditSetting;
            if (res.data.check_lists.length == 0)
                this.form.check_lists = [{
                    name: "",
                    attachment: false
                }];
            if (res.data.approval_layers.length == 0)
                this.form.approval_layers = [{
                    role_id: "",
                    role_name: '',
                    layer: 1
                }];
            if (res.data.collection_approval_layers.length == 0)
                this.form.collection_approval_layers = [{
                    role_id: "",
                    role_name: '',
                    layer: 1
                }];
        });
    }

    save() {
        // @ts-ignore
        this.$refs.formValidator.validate().then(async (success: boolean) => {
            if (!success) return;
            this.loading = true;
            await this.$http.post(this.$api('/credit-setting'), this.form).then((res: any) => {
                this.$notify({
                    title: 'Success',
                    message: 'Saved successfully',
                    type: 'success'
                });
            }).catch((err: any) => {
                (this.$refs.formValidator as Vue & {
                    setErrors: (errors: []) => any;
                }).setErrors(err.response.data.errors);
            }).finally(() => {
                this.loading = false;
            });
        });
    }

    addNewRow(type: string) {
        if (type == this.TYPES.CHECK_LIST)
            this.form.check_lists.push({
                name: '',
                attachment: false
            });
        else if (type == this.TYPES.APPROVAL_LAYER)
            this.form.approval_layers.push({
                role_id: '',
                role_name: '',
                layer: ''
            });
        else if (type == this.TYPES.COLLECTION_LAYER)
            this.form.collection_approval_layers.push({
                role_id: '',
                role_name: '',
                layer: ''
            });
    }

    deleteRow(index: number, type: string) {
        if (type == this.TYPES.CHECK_LIST)
            this.form.check_lists.splice(index, 1);
        else if (type == this.TYPES.APPROVAL_LAYER)
            this.form.approval_layers.splice(index, 1);
        else if (type == this.TYPES.COLLECTION_LAYER)
            this.form.collection_approval_layers.splice(index, 1);
    }

    selectedRole(row: any, data: any) {
        if (data) {
            row.role_name = data.name;
        }
    }

}
